import { IAnalyzeImageResponse, IImageInfo } from '@src/api/types'
import { FileSource, FileStatus } from '@src/components/FilePreview/types'
import { AxiosError } from 'axios'
import { makeAutoObservable } from 'mobx'

export class FileItem {
    name: string
    sourceType: FileSource
    size: number
    status: FileStatus = FileStatus.WAITING

    infoFromCloud?: Partial<IImageInfo>
    error?: AxiosError
    result?: IAnalyzeImageResponse
    binaryFile?: File
    abortController?: AbortController

    constructor(file: File | IImageInfo, sourceType = FileSource.FILE) {
        makeAutoObservable(this)

        this.name = file.name
        this.size = file.size
        this.sourceType = sourceType

        if (file instanceof File) {
            this.binaryFile = file
        }

        if (sourceType === FileSource.LINK) {
            this.infoFromCloud = {
                path: (file as IImageInfo).path,
                public_key: (file as IImageInfo).public_key,
            }
        }
    }

    setStatus(status: FileStatus) {
        this.status = status
    }

    setAbortController(controller: AbortController) {
        this.abortController = controller
    }

    abortRequest() {
        this.abortController?.abort()
    }

    setError(error: AxiosError) {
        this.error = error
    }

    setResult(result: IAnalyzeImageResponse) {
        this.result = result
    }
}
